import { KataPerformance } from "../../Api/competitorResultsApi";

export type KataEntry = {
    competitorId: number;
    publicId: string;
    firstName: string;
    lastName: string;
    academy: string;
    academyId: number;
    judgeScores: number[];
    totalScore: number | null;
    place: number | null;
    discardMinMax: boolean;
    performances: KataPerformance[];
};

export function getSortedScores(scores: number[]): number[] {
    return [...scores].sort((a, b) => a - b);
}

export function isDropped(sortedScores: number[], index: number, discardMinMax: boolean): boolean {
    if (!discardMinMax || sortedScores.length <= 2) {
        return false;
    }
    return index === 0 || index === sortedScores.length - 1;
}
